import React from "react"
import { Container, Grid  } from "@material-ui/core"
import { Link } from "gatsby"

import FacebookIcon from "@material-ui/icons/Facebook"
import LinkedInIcon from "@material-ui/icons/LinkedIn"
import TwitterIcon from "@material-ui/icons/Twitter"

const Footer = () => (
  <footer>
    <div className="gradient-bar"></div>
    <Container>
      <div className="footer-links">
        <div className="left">
          <div>
            <h4>
              SERVICES
            </h4>
            <ul>
              <li>
                <Link
                  to="/services/ai-machine-learning"
                  activeClassName="active"
                >
                  AI &amp; Machine Learning
                </Link>
              </li>

              <li>
                <Link
                  to="/services/data-management-analytics"
                  activeClassName="active"
                >
                  Data Management &amp; Analytics
                </Link>
              </li>

             
              <li>
                <Link to="/services/cloud-services" activeClassName="active">
                  Cloud Services
                </Link>
              </li>
              <li>
                <Link
                  to="/services/application-development"
                  activeClassName="active"
                >
                  Application Development
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h4>
              COMPANY
            </h4>
            <ul>
              <li>
                <Link to="/about-us" activeClassName="active">
                  About us
                </Link>
              </li>
              <li>
                <Link to="/our-team" activeClassName="active">
                  Our Team
                </Link>
              </li>
              <li>
                <Link to="/careers" activeClassName="active">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/contact-us" activeClassName="active">
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
          {/*
          <div>
            <h4>
              MISC
            </h4>
            <ul>
              <li>
                <Link to="/resources" activeClassName="active">
                  Resources
                </Link>
              </li>              
            </ul>
          </div>
          */}
        </div>
        <div className="right">
         
            <h4>Follow Us</h4>
            <div>
          <Grid container spacing={1} alignItems="center">                
                
                <Grid item>
                  <a href="https://www.facebook.com/InVizAI/" target="_blank">
                  <FacebookIcon fontSize="small" />
                  </a>
                </Grid>
                <Grid item>
                  <a href="https://www.linkedin.com/company/inviz-ai/" target="_blank">
                  <LinkedInIcon fontSize="small" target="_blank"/>
                  </a>
                </Grid>
                <Grid item>
                  <a href="https://twitter.com/InViz_AI" target="_blank">
                  <TwitterIcon fontSize="small" />
                  </a>
                </Grid>
              </Grid></div>
      </div>
      </div>
    </Container>

    <div className="site-info">
      <Container>
        &copy; 2020. Inviz AI. All Rights Reserved.
        <span className="policies">
        <Link to="/privacy-policy" activeClassName="active">
          Privacy Policy
        </Link>
        &nbsp;&nbsp;&nbsp;
        <Link to="/terms-conditions" activeClassName="active">
          Terms &amp; Conditions
        </Link>
        </span>
      </Container>
    </div>
  </footer>
)

export default Footer
